import React, {Component} from "react"
import styles from "./Header.module.css"
import avedamaineLogo from "./parts/img/logo-avedamaine.png"
import {ReactComponent as SignatureIcon} from "./parts/img/signature.svg"

interface Props {}

export class Header extends Component<Props, {}> {
    public render() {
        return (
            <header className={styles.root}>
                <div className={styles.wrapper}>
                    <h1 className={styles.h1}>
                        <a href="https://www.capilo.com/" target="_blank" rel="noopener noreferrer">
                            <img
                                src={avedamaineLogo}
                                alt="avedamaine-logo"
                                className={styles.logo}
                            />
                        </a>
                    </h1>
                    <div className={styles.rightWrapper}>
                        <SignatureIcon className={styles.signatureIcon} />
                        <span className={styles.text}>ENROLL TO AVEDA MAINE</span>
                    </div>
                </div>
            </header>
        )
    }
}
